import { useEffect, useState, useContext } from "react";
import DataTable from "examples/Tables/DataTable";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import Pagination from "@mui/material/Pagination";
import { Card } from "@mui/material";
import { LanguageContext } from "App";

const UserBalanceTable = ({
  Entries,
  GetEntries,
  SearchRequest,
  setSearchRequest,
  fromNormalDetails = false,
}) => {
  const { translations } = useContext(LanguageContext);

  const TableColumns = [
    {
      Header: translations.createAccountsessionPackageSearchId,
      accessor: "Id",
      align: "left",
    },

    {
      Header: translations.usrBalanceEnterieCurrentBalance,
      accessor: "CurrentBalance",
      align: "left",
    },
    {
      Header: translations.usrBalanceEnterieBalanceVariation,
      accessor: "BalanceVariation",
      align: "center",
    },
    { Header: translations.usrBalanceEnterieDescription, accessor: "Description", align: "center" },
    { Header: translations.usrBalanceEnterieTimeStamp, accessor: "TimeStamp", align: "center" },
    // Only include ID column if NOT from normal details
    ...(fromNormalDetails
      ? []
      : [{ Header: translations.usrBalanceEnterieUserId, accessor: "UserId", align: "center" }]),
    {
      Header: translations.usrBalanceEnterieAccountingEntryId,
      accessor: "AccountingEntryId",
      align: "center",
    },
    {
      Header: translations.usrBalanceEnterieAccountingSessionId,
      accessor: "AccountingSessionId",
      align: "center",
    },
    { Header: translations.usrBalanceEnteriePackageId, accessor: "PackageId", align: "center" },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);
  const [IsLoaded, setIsLoaded] = useState(false);

  const MakeTableRow = (Entry) => {
    const rowData = {
      Id: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.id}
        </MDTypography>
      ),
      CurrentBalance: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.currentBalance}
        </MDTypography>
      ),

      BalanceVariation: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.balanceVariation}
        </MDTypography>
      ),
      Description: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.description}
        </MDTypography>
      ),

      TimeStamp: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {Entry.timeStamp}
        </MDTypography>
      ),

      AccountingEntryId: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          Id: {Entry.getAccountingEntry && Entry.getAccountingEntry.id},
        </MDTypography>
      ),

      AccountingSessionId: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          Id: {Entry.getAccountingSession && Entry.getAccountingSession.id}, Name:{" "}
          {Entry.getAccountingSession &&
            Entry.getAccountingSession.getSession &&
            Entry.getAccountingSession.getSession.name}
        </MDTypography>
      ),

      PackageId: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          Id: {Entry.getPackage && Entry.getPackage.id}, Name:{" "}
          {Entry.getPackage && Entry.getPackage.packageName}
        </MDTypography>
      ),
    };

    if (!fromNormalDetails) {
      rowData.UserId = (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          Id: {Entry.getUser && Entry.getUser.userId}, Name: {Entry.getUser && Entry.getUser.name}
        </MDTypography>
      );
    }

    return rowData;
  };

  const RefreshTable = (resList) => {
    const sortedData = [...resList].sort((a, b) => {
      // If you want to sort by timestamp (assuming it's a date string):
      // return new Date(b.timeStamp) - new Date(a.timeStamp);

      // Sorting by id (assuming it's a number)
      return b.id - a.id;
    });
    const rows = sortedData.map((Entry) => MakeTableRow(Entry));
    setTableDataRows(rows);
  };

  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);

  useEffect(async () => {
    SearchRequest.pagingParams.PageNumber = Page;
    setSearchRequest(SearchRequest);
    GetEntries();
  }, [Page]);

  useEffect(() => {
    if (Entries.list.length > 0) {
      setPaginationPages(Entries.totalPages);
      RefreshTable(Entries.list);
    }
  }, [Entries]);

  return (
    <Card className="mt-5">
      <MDBox
        mt={-3}
        py={3}
        px={2}
        sx={{
          borderTopLeftRadius: "1.1rem",
          borderTopRightRadius: "1.1rem",
          backgroundColor: fromNormalDetails
            ? "#linear-gradient(195deg, rgb(73, 163, 241), rgb(26, 115, 232))"
            : "#3560AD",
        }}
        bgColor="info"
        coloredShadow="info"
      >
        <div className="text-center">
          <MDTypography variant="h6" color="white">
            {translations.usrBalanceEnterieUserBalancesTable}
          </MDTypography>
        </div>
      </MDBox>
      <MDBox p={3}>
        <DataTable
          table={{ columns: TableColumns, rows: TableDataRows }}
          isSorted={false}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>

      <div className="text-right mx-3 my-4">
        <Pagination
          count={PaginationPages}
          color="primary"
          onChange={(e, num) => setPage(num)}
          className="float-right"
        />
      </div>
    </Card>
  );
};

export default UserBalanceTable;
